import React from 'react';
import ResultCount from '../components/facets/count/ResultCount';
import SearchFiltersMulti from '../components/facets/filters/SearchFiltersMulti';
import Pagination from '../components/facets/pagination/Pagination';
import SortOrder from '../components/facets/sort';
import {
    nameSortAsc,
    nameSortDesc,
    querySummaryRelInfoController, relatedInfoPagerController, relevanceSortCriterion, relInfoFacetsControllerList, reliSortController
} from '../controllers/searchresultscontroller';
import '../plp/plp.scss';
import RelatedInfo from '../relatedInfo/RelatedInfo';

export default function RelatedResults({ relatedState, queryState, setQueryState }) {

    const relatedInfoControllerConfig = [{ key: 'content_type', label: 'Content Type' }];
    return (
        <div className="container">
            <div className="row">
                <div className="col-lg-3">
                    <div className="plp__filter plp__left-filter">
                        <div className="plp__left-filterbutton">
                            <SearchFiltersMulti
                                title={'Filter'}
                                filterTitleClass={'plp__filter-title'}
                                filterBodyClasess={'asdf'}
                                facetControllerList={relInfoFacetsControllerList}
                                controllerConfig={relatedInfoControllerConfig}
                                presetFacet={null}
                                queryState={queryState}
                            />
                        </div>
                        <div>
                            <SortOrder
                                controller={reliSortController}
                                nameSortAsc={nameSortAsc}
                                nameSortDesc={nameSortDesc}
                                relevanceSortCriterion={relevanceSortCriterion}
                            />
                        </div>
                    </div>
                </div>
                <div className="col-lg-9">
                    <div className="plp__right-filter">
                        <div className="plp__right-filter-buttonselect">
                            <div className="plp__right-filter-mobile-filter">
                                <SortOrder
                                    controller={reliSortController}
                                    nameSortAsc={nameSortAsc}
                                    nameSortDesc={nameSortDesc}
                                    relevanceSortCriterion={relevanceSortCriterion}
                                />
                            </div>
                        </div>
                        <ResultCount
                            controller={querySummaryRelInfoController}
                            queryState={queryState}
                            setQueryState={setQueryState}
                        />
                    </div>
                    <RelatedInfo relatedState={relatedState} />
                    <div>
                        <Pagination controller={relatedInfoPagerController} />
                    </div>
                </div>
            </div>
        </div>
    );
}
